/* ============================================================
   DNI · Ficha de producto — interacción del lado del cliente
   (port de lo que en ProductScreen era estado de React)
   - Botón "copiar" código SKU
   - Selector de cantidad − / +
   - Cambiar la imagen principal al tocar un thumbnail
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Copiar código ---------- */
  var copyBtn = document.querySelector('[data-copy-code]');
  var codeEl = document.querySelector('[data-code]');
  if (copyBtn && codeEl && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(codeEl.getAttribute('data-code') || codeEl.textContent).then(function () {
        var prev = copyBtn.textContent;
        copyBtn.textContent = 'copiado ✓';
        setTimeout(function () { copyBtn.textContent = prev; }, 1400);
      });
    });
  }

  /* ---------- Cantidad − / + (funciona con varios widgets: PDP y carrito) ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (qty) {
    var input = qty.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(qty.getAttribute('data-qty-min'), 10);
    if (isNaN(min)) min = 1; // PDP puede fijar el MOQ vía data-qty-min
    function clamp(n) { return n < min ? min : n; }
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || min) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || min) + 1;
    });
    input.addEventListener('change', function () {
      input.value = clamp(parseInt(input.value, 10) || min);
    });
  });

  /* ---------- Galería PDP: thumbs + flechas + lightbox ---------- */
  var gallery = document.querySelector('[data-pdp-gallery]');
  var mainImg = document.querySelector('[data-pdp-main-img]');
  if (gallery && mainImg) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-thumb]'));
    var srcs = thumbs.map(function (t) { return t.getAttribute('data-pdp-thumb'); });
    if (!srcs.length) srcs = [mainImg.currentSrc || mainImg.src];
    var idx = 0;
    var lb = document.querySelector('[data-pdp-lightbox]');
    var lbImg = document.querySelector('[data-pdp-lb-img]');

    function setIndex(i, syncLb) {
      idx = (i + srcs.length) % srcs.length;
      mainImg.src = srcs[idx];
      mainImg.removeAttribute('srcset');
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === idx); });
      if (syncLb && lbImg) lbImg.src = srcs[idx];
    }

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { setIndex(k, false); }); });

    var prev = gallery.querySelector('[data-pdp-prev]');
    var next = gallery.querySelector('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { setIndex(idx - 1, false); });
    if (next) next.addEventListener('click', function () { setIndex(idx + 1, false); });

    /* Lightbox (galería ampliada) */
    var zoom = gallery.querySelector('[data-pdp-zoom]');
    function openLb() { if (!lb) return; lbImg.src = srcs[idx]; lb.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeLb() { if (!lb) return; lb.hidden = true; document.body.style.overflow = ''; }
    if (zoom) zoom.addEventListener('click', openLb);
    mainImg.style.cursor = 'zoom-in';
    mainImg.addEventListener('click', openLb);

    if (lb) {
      var lbClose = lb.querySelector('[data-pdp-lb-close]');
      var lbPrev = lb.querySelector('[data-pdp-lb-prev]');
      var lbNext = lb.querySelector('[data-pdp-lb-next]');
      if (lbClose) lbClose.addEventListener('click', closeLb);
      if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); setIndex(idx - 1, true); });
      if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); setIndex(idx + 1, true); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowLeft') setIndex(idx - 1, true);
        else if (e.key === 'ArrowRight') setIndex(idx + 1, true);
      });
    }
  }
})();

/* ------------------------------------------------------------------
   "Leer más" para textos largos
   ------------------------------------------------------------------
   Recorta cualquier bloque con [data-colapsa] a la altura de su
   data-max (px) y agrega un botón para desplegarlo. Solo actúa si el
   texto SOBRA de verdad: un párrafo corto se deja tal cual, sin botón.
   El texto completo siempre está en el HTML (solo se oculta con CSS),
   así que buscadores y Ctrl+F lo siguen encontrando.
------------------------------------------------------------------ */
(function () {
  document.querySelectorAll('[data-colapsa]').forEach(function (bloque) {
    var max = parseInt(bloque.getAttribute('data-max'), 10) || 150;
    // Margen de 24px: si sobra menos que eso, no vale la pena el botón.
    if (bloque.scrollHeight <= max + 24) return;

    bloque.classList.add('colapsado');
    bloque.style.setProperty('--colapsa-max', max + 'px');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'leer-mas';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Leer más';
    bloque.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      var abierto = bloque.classList.toggle('colapsado') === false;
      btn.textContent = abierto ? 'Leer menos' : 'Leer más';
      btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
  });
})();
